<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="BGVCheckListForm" (ngSubmit)="Validate(BGVCheckListForm)" #BGVCheckListForm="ngForm"
        novalidate>
        <div class="card-header">
            Check List
        </div>
        <div class="card-body">
            <div class="row pb-2">
                <div class="col-md-10">
                    <label for="CheckListName" class="form-font-label">Check Name<span
                            class="text-danger">*</span></label>
                    <input type="text" maxlength="100" class="form-control" placeholder="Ex. Check Name"
                        id="CheckListName" name="CheckListName" [(ngModel)]="CheckList.CheckListName"
                        #CheckListName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter check name!
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="InitiationDays" class="form-font-label">Days<span class="text-danger">*</span></label>
                    <input type="text" maxlength="3" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                        class="form-control" placeholder="Ex. 01" id="AllowRegularizationForDays"
                        name="InitiationDays"
                        [(ngModel)]="CheckList.InitiationDays"
                        #InitiationDays="ngModel" required>

                    <div class="invalid-feedback">
                        Please enter days!
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button *ngIf="(this.common.PageRight.IsEdit && this.CheckList.ESS_BGVCheckListMasterId > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Update':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>